import { jsx as _jsx } from "react/jsx-runtime";
import TabelaBase from '../../library/TabelaBase';
import { getLayouts } from './layouts';
export default function TabelaEstatisticas(props) {
    const { titulo = 'Estatísticas', rows, layout, benches } = props;
    return (_jsx(TabelaBase, { rows: rows, layout: layout, titulo: titulo, layouts: getLayouts(benches) }));
}
